import { render, staticRenderFns } from "./page-not-available-in-language.vue?vue&type=template&id=f6c8930c"
import script from "./page-not-available-in-language.vue?vue&type=script&lang=js"
export * from "./page-not-available-in-language.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports